import type { RequestFn } from '../http';

export interface Supplier {
  id: string;
  name: string;
  email: string | null;
  phone: string | null;
  website: string | null;
  notes: string | null;
  isActive: boolean;
}

export interface CreateSupplierInput {
  name: string;
  email?: string | null;
  phone?: string | null;
  website?: string | null;
  notes?: string | null;
}

export function createSuppliersApi(request: RequestFn) {
  return {
    /** Lieferantensuche im Verzeichnis (Name, case-insensitive). */
    async searchSuppliers(q: string, limit = 25) {
      const params = new URLSearchParams({ q, limit: String(limit) });
      return request<{ suppliers: Supplier[] }>(`/suppliers?${params}`);
    },

    /** Neuen Lieferanten anlegen (oder bestehenden mit gleichem Namen zurückgeben). */
    async createSupplier(data: CreateSupplierInput) {
      return request<{ supplier: Supplier }>('/suppliers', {
        method: 'POST',
        body: JSON.stringify(data),
      });
    },

    async getSupplier(id: string) {
      return request<{ supplier: Supplier }>(`/suppliers/${id}`);
    },
  };
}
